class Constants {
    static BASE_PATH = "/cms"
    static GUEST_ACTIVATION_PAGE = "guestactivation";
    static BRAND_PAGE = "brand";
    static BRANCH_PAGE = "branch";
    static SCREEN_PAGE = "screen";
    static DASHBOARD_PAGE = "dashboard";
    static ACTIVITYLOG_PAGE = "activitylog";
    static MEDIALOG_PAGE = "medialog";
    static ANALYTICS_PAGE = "analytics";
    static LICENSE_PAGE = "license";
    static CAMPAIGN_PAGE = "campaign";
    static CAMPAIGN_CONTENT_PAGE = "campaign_content";
    static CAMPAIGN_CONTENT_CHANNEL_PAGE = "campaign_content_channel_page";
    static TIMELINE_PAGE = "timeline";
    static LAYOUT_PAGE = "layout";
    static PLAYLIST_PAGE = "playlist";
    static MEDIA_PAGE = "media";
    static MEDIA_TRASH_PAGE = "media_trash";
    static BRAND_PLAYLIST_PAGE = "brand_playlist";
    static BRAND_MEDIA_PAGE = "brand_media";
    static BRAND_MEDIA_TRASH_PAGE = "brand_media_trash";
    static EVENT_PAGE = "event";
    static WIDGET_PAGE = "widget";
    static WIDGET_INSTANCE_PAGE = "widget_instance";
    static USER_PAGE = "user";
    static LOGIN_PAGE = "login";

    static PAGE_REQUIREMENTS = [
        { id: Constants.GUEST_ACTIVATION_PAGE, require: [] },
        { id: Constants.BRAND_PAGE, require: [] },
        { id: Constants.BRANCH_PAGE, require: ["brand"] },
        { id: Constants.SCREEN_PAGE, require: ["brand", "branch"] },
        { id: Constants.DASHBOARD_PAGE, require: ["brand"] },
        { id: Constants.ACTIVITYLOG_PAGE, require: ["brand"] },
        { id: Constants.MEDIALOG_PAGE, require: ["brand"] },
        { id: Constants.ANALYTICS_PAGE, require: ["brand"] },
        { id: Constants.LICENSE_PAGE, require: ["brand"] },
        { id: Constants.EVENT_PAGE, require: ["brand", "branch"] },
        { id: Constants.CAMPAIGN_PAGE, require: ["brand", "branch"] },
        { id: Constants.CAMPAIGN_CONTENT_PAGE, require: ["brand", "branch"] },
        { id: Constants.CAMPAIGN_CONTENT_CHANNEL_PAGE, require: ["brand", "branch"] },
        { id: Constants.LAYOUT_PAGE, require: ["brand", "branch"] },
        { id: Constants.BRAND_PLAYLIST_PAGE, require: ["brand"] },
        { id: Constants.BRAND_MEDIA_PAGE, require: ["brand"] },
        { id: Constants.BRAND_MEDIA_TRASH_PAGE, require: ["brand"] },
        { id: Constants.PLAYLIST_PAGE, require: ["brand", "branch"] },
        { id: Constants.MEDIA_PAGE, require: ["brand", "branch"] },
        { id: Constants.MEDIA_TRASH_PAGE, require: ["brand", "branch"] },
        { id: Constants.WIDGET_PAGE, require: ["brand", "branch"] }
        // { id: Constants.BRAND_PAGE, require: [] },
        // { id: Constants.BRANCH_PAGE, require: ["brand"] },
        // { id: Constants.SCREEN_PAGE, require: ["brand", "branch"] },
        // { id: Constants.DASHBOARD_PAGE, require: ["brand"] },
        // { id: Constants.LICENSE_PAGE, require: ["brand"] },
        // { id: Constants.EVENT_PAGE, require: ["brand", "branch"] },
        // { id: Constants.CAMPAIGN_PAGE, require: ["brand"] },
        // { id: Constants.CAMPAIGN_CONTENT_PAGE, require: ["brand"] },
        // { id: Constants.CAMPAIGN_CONTENT_CHANNEL_PAGE, require: ["brand"] },
        // { id: Constants.LAYOUT_PAGE, require: ["brand"] },
        // { id: Constants.PLAYLIST_PAGE, require: ["brand"] },
        // { id: Constants.MEDIA_PAGE, require: ["brand"] },
        // { id: Constants.WIDGET_PAGE, require: ["brand"] }
    ]

    static SIDEMENU_BUTTONS = [
        { url: "/brand", id: Constants.BRAND_PAGE, title: "Workspaces", icon: "/cms/assets/svgs/icons/menu_brand_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_brand_icon_dark.svg", visible: false },
        { url: "/dashboard", id: Constants.DASHBOARD_PAGE, title: "Dashboard", icon: "/cms/assets/svgs/icons/menu_dashboard_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_dashboard_icon_dark.svg", visible: true },
        { url: "/branch", id: Constants.BRANCH_PAGE, title: "Locations", icon: "/cms/assets/svgs/icons/menu_branch_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_branch_icon_dark.svg", visible: true },
        { url: "/brand_media", id: Constants.BRAND_MEDIA_PAGE, title: "Medias", icon: "/cms/assets/svgs/icons/menu_media_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_media_icon_dark.svg", visible: true },
        { url: "/brand_playlist", id: Constants.BRAND_PLAYLIST_PAGE, title: "Playlists", icon: "/cms/assets/svgs/icons/menu_playlist_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_playlist_icon_dark.svg", visible: true },
        { url: "/brand_media_trash", id: Constants.BRAND_MEDIA_TRASH_PAGE, title: "Trash", icon: "/cms/assets/svgs/icons/menu_trash_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_trash_icon_dark.svg", visible: true },
        { url: "/activitylog", id: Constants.ACTIVITYLOG_PAGE, title: "Activity Log", icon: "/cms/assets/svgs/icons/menu_activitylog_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_activitylog_icon_dark.svg", visible: true },
        { url: "/medialog", id: Constants.MEDIALOG_PAGE, title: "Media Log", icon: "/cms/assets/svgs/icons/menu_medialog_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_medialog_icon_dark.svg", visible: true },
        { url: "/analytics", id: Constants.ANALYTICS_PAGE, title: "Analytics", icon: "/cms/assets/svgs/icons/menu_analytics_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_analytics_icon_dark.svg", visible: true },
        { url: "/screen", id: Constants.SCREEN_PAGE, title: "Screens", icon: "/cms/assets/svgs/icons/menu_screen_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_screen_icon_dark.svg", visible: true },
        { url: "/media", id: Constants.MEDIA_PAGE, title: "Medias", icon: "/cms/assets/svgs/icons/menu_media_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_media_icon_dark.svg", visible: true },
        { url: "/playlist", id: Constants.PLAYLIST_PAGE, title: "Playlists", icon: "/cms/assets/svgs/icons/menu_playlist_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_playlist_icon_dark.svg", visible: true },
        { url: "/campaign", id: Constants.CAMPAIGN_PAGE, title: "Campaigns", icon: "/cms/assets/svgs/icons/menu_campaign_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_campaign_icon_dark.svg", visible: true },
        { url: "/campaign_content", id: Constants.CAMPAIGN_CONTENT_PAGE, title: "Campaigns / Contents", icon: "/cms/assets/svgs/icons/menu_campaign_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_campaign_icon_dark.svg", visible: false },
        { url: "/campaign_content_channel", id: Constants.CAMPAIGN_CONTENT_CHANNEL_PAGE, title: "Campaigns / Contents / Channel", icon: "/cms/assets/svgs/icons/menu_campaign_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_campaign_icon_dark.svg", visible: false },
        { url: "/event", id: Constants.EVENT_PAGE, title: "Events", icon: "/cms/assets/svgs/icons/menu_event_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_event_icon_dark.svg", visible: true },
        { url: "/widget", id: Constants.WIDGET_PAGE, title: "Widgets", icon: "/cms/assets/svgs/icons/menu_widget_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_widget_icon_dark.svg", visible: true },
        { url: "/license", id: Constants.LICENSE_PAGE, title: "License", icon: "/cms/assets/svgs/icons/menu_license_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_license_icon_dark.svg", visible: true },
        { require: ["brand", "branch"], url: "/timeline", id: Constants.TIMELINE_PAGE, title: "Timelines", icon: "/cms/assets/svgs/icons/menu_timeline_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_timeline_icon_dark.svg", visible: true },
        { url: "/channel", id: Constants.LAYOUT_PAGE, title: "Channels", icon: "/cms/assets/svgs/icons/menu_layout_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_layout_icon_dark.svg", visible: false },
        { url: "/media_trash", id: Constants.MEDIA_TRASH_PAGE, title: "Trash", icon: "/cms/assets/svgs/icons/menu_trash_icon.svg", dark_icon: "/cms/assets/svgs/icons/menu_trash_icon_dark.svg", visible: true },
    ]

    static checkPageRequirements = (pageID, key) => {
        const page = Constants.PAGE_REQUIREMENTS.find(item => {
            return item.id === pageID;
        })

        if (!page)
            return false;
        else {
            return page.require.includes(key)
        }
    }
    static getMenuTitleByID = (id) => {

        const obj = Constants.SIDEMENU_BUTTONS.find((obj) => {
            return obj.id === id
        });

        if (obj)
            return obj.title
        else
            return ""
    }

    static getMenuTitleByPath = (path) => {
        const obj = Constants.SIDEMENU_BUTTONS.find((obj) => {
            return obj.url === path
        });

        if (obj)
            return obj.title
        else
            return ""
    }
}

export default Constants;